<template>
  <main class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">质检单管理</span>
    </div>
    <div class="search-one" style="margin-top: 70px;">
      <div class="search-item">
        质检单号
        <Input class='ml10 mr20 w200' v-model="screen_data.check_bill_no" placeholder="请输入客户名称" />
        子账号名称
        <Input class='ml10 mr20 w200' v-model="screen_data.client_name" placeholder="请输入客户名称" />
        客户编号<Input class='ml10 mr20 w200' v-model="screen_data.user_name" placeholder="请输入客户编号" />
      </div>
      <div class="search-item">
        状态<Select class='ml10 mr20 w100' v-model="screen_data.in_bill_status" placeholder="请选择">
          <Option v-for="item in status" :key="item.value" :value="item.value">{{item.label}}</Option>
        </Select>
        提交日期
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>

    </div>
    <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

    <Modal :title="title" v-model="show_detail" width="1200">
      <div class="details f14 pl20">
        <p class="mt5">质检单号： {{detailInfo.check_bill_no||'-'}}</p>
        <p class="mt5">质检库房： {{detailInfo.warehouse_name||'-'}}</p>
        <p class="mt5">客户编号： {{detailInfo.client_code||'-'}}</p>
        <p class="mt5">客户姓名： {{detailInfo.client_name||'-'}}</p>
        <p class="mt5">提交日期： {{detailInfo.create_date||'-'}}</p>
        <p class="mt5">质检完成日期： {{detailInfo.fee_create_date||'-'}}</p>
        <p class="mt5">质检费： {{detailInfo.total_fee||'-'}}</p>
      </div>
      <Table class="mt20" border :columns="detail_columns" :data="detail_list">
        <template slot-scope="{ row, index }" slot="images">
          <span class="item-img mr10 fl" v-for="(v,i) in row.image_arr" :key="i" :src="v">
            <el-image style="width: auto; height: 30px;margin-top: 10px;" :src="v" :preview-src-list="row.image_arr">
            </el-image>
            <Icon v-if="row.$isEdit" @click="delImg(index,i)" class="i-colse" type="ios-close-circle" size="16" />
          </span>
        </template>
      </Table>
      <p class="pt20 pl20"><b>sku详情：</b></p>
      <Table class="mt20" border :columns="detailsku_columns" :data="detailsku_list">
        <template slot-scope="{ row, index }" slot="images">
          <span class="item-img mr10 fl" v-for="(v,i) in row.image_arr" :key="i" :src="v">
            <el-image style="width: auto; height: 30px;margin-top: 10px;" :src="v" :preview-src-list="row.image_arr">
            </el-image>
            <Icon v-if="row.$isEdit" @click="delImg(index,i)" class="i-colse" type="ios-close-circle" size="16" />
          </span>
        </template>
      </Table>
      <div slot="footer" class="tc">
        <button class="ivu-btn" @click="show_detail=false">取消</button>
        <button v-if="detailInfo.status==30" class="ivu-btn ivu-btn-primary"
          @click="confirmFee(detailInfo.check_bill_no)">确认批价</button>
      </div>
    </Modal>

    <!-- 声音组件 -->
    <Voice ref="child"></Voice>
    <VoiceText ref="voiceText"></VoiceText>
  </main>
</template>

<script>
  import Paging from '@/components/common/paging';
  import Voice from "@/components/common/voice";
  import VoiceText from "@/components/common/voice.text";
  export default {
    components: {
      Paging,
      Voice,
      VoiceText
    },
    data() {
      return {
        error_msg: '', //错误信息
        table_data: { //列表数据
          columns: [],
          data: []
        },
        website: [],
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          pageNum: 1,
          pageSize: 10,
          warehouse_id: ''
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        status: [{ //-10-已取消，0-提交，10-质检中，20-翻新中，30-批价确认，40-质检完成
          value: -10,
          label: '已取消'
        }, {
          value: 0,
          label: '已提交'
        }, {
          value: 10,
          label: '质检中'
        }, {
          value: 20,
          label: '翻新中'
        }, {
          value: 30,
          label: '批价待确认'
        }, {
          value: 40,
          label: '质检完成'
        }],
        title: '查看详情',
        show_detail: false,
        detailsku_columns: [{
          title: '入库包裹号',
          key: 'in_bill_no',
          minWidth: 200,
          tooltip: true
        },{
          title: 'SKU',
          key: 'sku',
          minWidth: 150,
          tooltip: true
        }, {
          title: '正常数量',
          key: 'count_ok',
          minWidth: 100,
          tooltip: true
        }, {
          title: '翻新数据',
          key: 'count_renovate',
          minWidth: 100,
          tooltip: true
        }, {
          title: '丢弃数量',
          key: 'count_discard',
          minWidth: 100,
          tooltip: true
        },],
        detailsku_list: [],
        detailInfo: {},
        detail_columns: [{
          title: 'SKU',
          key: 'sku',
          minWidth: 100,
          tooltip: true
        }, {
          title: '产品名称',
          key: 'product_name',
          minWidth: 100,
          tooltip: true
        }, {
          title: '尺寸',
          key: 'size',
          minWidth: 100,
          tooltip: true
        }, {
          title: '颜色',
          key: 'color',
          minWidth: 100,
          tooltip: true
        }, {
          title: '图片',
          slot: 'images',
          width: 100,
        }, {
          title: '备注',
          key: 'remark',
          minWidth: 100,
          tooltip: true
        }, {
          title: '创建时间',
          key: 'create_date',
          minWidth: 100,
          tooltip: true
        }, {
          title: '正常数量',
          key: 'count_ok',
          minWidth: 100,
          tooltip: true
        }, {
          title: '翻新数据',
          key: 'count_renovate',
          minWidth: 100,
          tooltip: true
        }, {
          title: '丢弃数量',
          key: 'count_discard',
          minWidth: 100,
          tooltip: true
        }, ],
        detail_list: []
      }
    },
    methods: {
      init() {
        this.table_data.columns = this.setColumns();
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/zj/check/bill/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      exportData() {
        this.$axios.get("/user/list/excel", {
          params: this.screen_data
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      cancel(check_bill_no) { //取消质检单
        this.$axios.delete("/zj/check/bill", {
          params: {
            check_bill_no: check_bill_no
          }
        }).then(res => {
          if (res.success) {
            this.$Message.info('取消成功');
            this.getList()
          }
        })
      },
      confirmFee(check_bill_no) { //确认批价
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认批价吗？</p>',
          onOk: () => {
            this.$axios.post("/zj/check/bill/fee/confirm?check_bill_no=" + check_bill_no).then(res => {
              if (res.success) {
                this.$Message.info('确认成功');
                this.show_detail = false;
                this.getList()
              }
            })
          },
          onCancel: () => {

          }
        });
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '质检单号',
          key: 'check_bill_no',
          tooltip: true,
          minWidth: 180,
        }, {
          title: '子账户名称',
          key: 'client_name',
          tooltip: true,
          minWidth: 170,
        }, {
          title: '客户编号',
          key: 'client_code',
          tooltip: true,
          minWidth: 100,
        }, {
          title: 'SKU数',
          key: 'sku_count',
          minWidth: 100,
        }, {
          title: '产品总数',
          key: 'product_count',
          minWidth: 100,
        }, {
          title: '质检费',
          key: 'total_fee',
          minWidth: 100,
        }, {
          title: '状态',
          minWidth: 150,
          render: (h, params) => {
            let txt = '-'
            let index = this.status.findIndex(v => v.value == params.row.status)
            if (index > -1) {
              txt = this.status[index].label
            }
            return h("span", txt);
          }
        }, {
          title: '提交时间',
          key: 'create_date',
          minWidth: 185,
        }, {
          title: '操作',
          minWidth: 140,
          render: (h, params) => {
            let doms = [];
            if (params.row.status == 0) {
              doms.push(h('span', {
                style: {
                  cursor: "pointer",
                  color: "#0062da",
                  'margin-right': '15px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '取消质检单',
                      content: '<p>确定取消质检单：' + params.row.check_bill_no + '吗？</p>',
                      onOk: () => {
                        this.cancel(params.row.check_bill_no)
                      },
                      onCancel: () => {

                      }
                    });
                  }
                }
              }, '取消'));
            }
            doms.push(h('span', {
              style: {
                cursor: "pointer",
                color: "#0062da"
              },
              on: {
                click: () => {
                  this.detailInfo = {
                    ...params.row
                  }
                  this.show_detail = true;
                  this.getDetail(params.row.check_bill_no)
                }
              }
            }, '查看详情'));
            return h("div", doms);
          }
        }];
        return arr;
      },
      getDetail(check_bill_no) {
        this.title = '质检单号' + check_bill_no + '详情'
        this.$axios.get("/zj/check/bill/list/detail?check_bill_code=" + check_bill_no).then(res => {
          if (res.success && res.data && res.data.length) {
            res.data.forEach(v => {
              v.image_arr = []
              if (v.image_url) {
                v.image_arr.push(v.image_url)
              }
            })
            this.detail_list = res.data;
          } else {
            this.detail_list = []
          }
        })
        this.$axios.get("/zj/check/bill/in/sku?check_bill_no=" + check_bill_no).then(res => {
          if (res.success && res.data && res.data.length) {
            res.data.forEach(v => {
              v.image_arr = []
              if (v.image_url) {
                v.image_arr.push(v.image_url)
              }
            })
            this.detailsku_list = res.data;
          } else {
            this.detailsku_list = []
          }
        })
      }
    },
    created() {
      this.table_data.columns = this.setColumns()
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id');
      // this.screen_data.client_code = localStorage.getItem('client_code') || ''
      if (!this.screen_data.warehouse_id) {
        this.$Message.info('请选择仓库');
        return false
      }
      // if (!this.screen_data.client_code) {
      //   this.$Message.info('请选择子账户');
      //   return false
      // }
      this.getList()
    }
  }
</script>

<style scoped>
  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 40px;
    margin-top: 40px;
  }

  .inbill-code {
    width: 600px;
    padding: 20px 0;
    text-align: center;
    font-size: 20px;
    background-color: #f6f8f9;
    margin-bottom: 20px;
  }

  .client-code {
    width: 200px;
    padding: 10px 30px;
    font-size: 15px;
    background-color: #f6f8f9;
  }

  .client-code span {
    display: inline-block;
    font-size: 30px;
    padding: 10px 0;
    font-weight: bold;
  }

  .btn-print {
    padding: 10px 30px;
    height: auto;

  }
</style>



// WEBPACK FOOTER //
// src/pages/tuihuozhijian/zhijiandan/list.vue